import {
  FileText,
  TrendingUp,
  TrendingDown,
  ListChecks,
  Eye,
  Edit3,
  FlaskConical,
} from 'lucide-react';

// Abbey brand colors
export const ABBEY_COLORS = {
  primary: '#1e3a5f',
  secondary: '#2d5a87',
  accent: '#4a90c2',
  gold: '#c9a227',
  text: '#1f2937',
  muted: '#6b7280',
  positive: '#059669',
  negative: '#dc2626',
  neutral: '#6b7280'
};

// Currency symbols by region
export const CURRENCY_SYMBOLS = {
  'UK': '\u00A3',
  'UAE': 'AED ',
  'US': '$',
  'EU': '\u20AC'
};

// Number formatting utilities
export const formatNumber = (value, currencySymbol = '') => {
  if (value == null || value === '' || isNaN(parseFloat(value))) return 'N/A';
  const num = Math.round(parseFloat(value));
  if (num < 0) {
    return `${currencySymbol}(${Math.abs(num).toLocaleString()})`;
  }
  return `${currencySymbol}${num.toLocaleString()}`;
};

export const formatPercent = (value) => {
  if (value == null || value === '' || isNaN(parseFloat(value))) return 'N/A';
  const num = parseFloat(value).toFixed(1);
  if (parseFloat(num) < 0) {
    return `(${Math.abs(parseFloat(num)).toFixed(1)}%)`;
  }
  return `${num}%`;
};

export const formatCurrency = (value, symbol = '\u00A3', decimals = 0) => {
  if (value == null || value === '' || isNaN(parseFloat(value))) return 'N/A';
  const num = parseFloat(value);
  if (decimals > 0) {
    const rounded = parseFloat(num.toFixed(decimals));
    if (rounded < 0) return `${symbol}(${Math.abs(rounded).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })})`;
    return `${symbol}${rounded.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
  }
  const rounded = Math.round(num);
  if (rounded < 0) return `${symbol}(${Math.abs(rounded).toLocaleString()})`;
  return `${symbol}${rounded.toLocaleString()}`;
};

// Wizard step definitions
export const BEVERAGE_WIZARD_STEPS = [
  { id: 1, name: 'Confirm Details', icon: FileText },
  { id: 2, name: 'Key Performance Indicators', icon: TrendingUp },
  { id: 3, name: 'PLU Variance Analysis', icon: TrendingDown },
  { id: 4, name: 'Allowances & Management', icon: ListChecks },
  { id: 5, name: 'ABV Check', icon: FlaskConical },
  { id: 6, name: 'Observations', icon: Edit3 },
  { id: 7, name: 'Review', icon: Eye },
];

export const FOOD_WIZARD_STEPS = [
  { id: 1, name: 'Confirm Details', icon: FileText },
  { id: 2, name: 'Key Performance Indicators', icon: TrendingUp },
  { id: 3, name: 'Allowances', icon: ListChecks },
  { id: 4, name: 'Observations', icon: Edit3 },
  { id: 5, name: 'Review', icon: Eye },
];

// Default empty sections structure
export const getDefaultSections = () => ({
  metrics: {
    stockholding_value: '',
    stockholding_days: '',
    sales_for_period: '',
    gp_percent: '',
    cos_percent: '',
    gp_before_allowances_percent: '',
    cos_before_allowances_percent: '',
    wastage_value: '',
    stocktake_result_value: '',
    stocktake_result_percent: '',
    exit_meeting_attended: null,
    yield_percent: '',
    gross_profit_amount: '',
    ytd_sales_amount: '',
    ytd_gross_profit_amount: '',
    ytd_gross_profit_percent: '',
    ytd_result_amount: '',
    ytd_result_percent: '',
    ytd_yield_percent: ''
  },
  history: {
    items: []
  },
  variance: {
    shortages: [],
    surpluses: []
  },
  allowances: [],
  management: [],
  abv_checks: [],
  food_allowances: [],
  observations: {
    key: '',
    root_causes: '',
    actions: ''
  }
});

export const MAX_HISTORY_ITEMS = 5;
